import React, { useState, useEffect } from "react";
import moment from "moment";
import "moment/locale/fr";
import {
  Button,
  Space,
  Form,
  Col,
  message,
  Row,
  Input,
} from "antd";
import {
  CloseOutlined,
  PlusOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { useAddExternalMember } from "../../api/api";
import { useTranslation } from "react-i18next";

export default function ExternalMemberForm({ close, movement_id, addElement }) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { mutateAsync: addExternalMember } = useAddExternalMember(movement_id);

  const handleSubmit = async () => {
    form
      .validateFields()
      .then(async function (values) {
        try {
          setLoading(true);

          console.log(values);

          const resp = await addExternalMember(values.members);

          addElement(resp);

          close();

          message.success(t("successful.recording"));
          setLoading(false);
        } catch (e) {
          setLoading(false);
          message.warning(t("error.recording"));
        }
      })
      .catch((errorInfo) => {
        console.log(errorInfo);
      });
  };

  return (
    <div className="flex  column rel h100">
      <div
        className="flex itemcenter justcenter  u-mar-bottom-s fixed w100 z999 bgwhite u-pad-horizontal-s u-pad-top-s"
        style={{ top: 0, borderBottom: "1px solid #DDD", paddingBottom: 10 }}
      >
        <div
          className="flex itemcenter justcenter cursor rad8 btnfilter u-mar-right-s abs"
          style={{ left: 34 }}
          onClick={() => close()}
        >
          <span className="fs15  " style={{ color: "#1a1a1a" }}>
            <CloseOutlined />
          </span>
        </div>
        <h2 className="fW600">
          {" "}
          {t("travelRequests.form.step1.button.label")}
        </h2>
        <div className="flex itemcenter abs" style={{ right: 34 }}>
          <Button
            type="primary"
            size="large"
            className="rad8"
            onClick={() => handleSubmit()}
          >
            <span className="fs16 av-heavy"> {t("add.button")} </span>
          </Button>
        </div>
      </div>
      <div className="u-mar-vertical-xxl  w50 mauto">
        <Form layout="vertical" className="rel" form={form}>
          <Row gutter={24}>
            <Col span={24}>
              <Form.List name="members">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{ display: "flex", marginBottom: 8 }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, "name"]}
                          rules={[{ required: true, message: t("required") }]}
                        >
                          <Input
                            placeholder={t("travelRequests.form.step1.label9")}
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "profession"]}
                          rules={[{ required: true, message: t("required") }]}
                        >
                          <Input
                            placeholder={t("travelRequests.form.step1.label10")}
                          />
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        {t("travelRequests.form.step1.button.label")}
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
}
